import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:8000/api';
const API_URL = `${API_BASE}/financiero`;

// Configurar axios para incluir el token de autenticación
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Becas CRUD
export const getBecas = async (params = {}) => {
  const { search, tipo_beca, estado, ordering, page, page_size } = params;
  let url = `${API_URL}/scholarships/`;
  const query = [];
  if (search) query.push(`search=${encodeURIComponent(search)}`);
  if (tipo_beca) query.push(`tipo_beca=${encodeURIComponent(tipo_beca)}`);
  if (estado !== undefined && estado !== '') query.push(`estado=${encodeURIComponent(estado)}`);
  if (ordering) query.push(`ordering=${encodeURIComponent(ordering)}`);
  if (page) query.push(`page=${page}`);
  if (page_size) query.push(`page_size=${page_size}`);
  if (query.length) url += `?${query.join('&')}`;
  const res = await axios.get(url);
  return res.data;
};

export const getBeca = async (id) => {
  const res = await axios.get(`${API_URL}/scholarships/${id}/`);
  return res.data;
};

export const createBeca = async (data) => {
  const res = await axios.post(`${API_URL}/scholarships/`, data);
  return res.data;
};

export const updateBeca = async (id, data) => {
  const res = await axios.put(`${API_URL}/scholarships/${id}/`, data);
  return res.data;
};

export const patchBeca = async (id, data) => {
  const res = await axios.patch(`${API_URL}/scholarships/${id}/`, data);
  return res.data;
};

export const deleteBeca = async (id) => {
  const res = await axios.delete(`${API_URL}/scholarships/${id}/`);
  return res.data;
};

/**
 * Obtener información de becas activas de un estudiante
 * @param {number} estudianteId - ID del estudiante
 * @returns {Promise<object>} - Datos de becas (activas e históricas)
 */
export const getEstudianteBecas = async (estudianteId) => {
  try {
    const res = await axios.get(`${API_URL}/estudiante/${estudianteId}/beca/`);
    return res.data;
  } catch (error) {
    console.error('Error al obtener becas del estudiante:', error);
    // Retornar estructura vacía para no romper el componente
    return {
      success: true,
      tiene_beca: false,
      beca_activa: null,
      becas_activas: [],
      historial_becas: []
    };
  }
};
